<template>
    <div class="dropzone-file">
        <div class="dropzone-file__icon">
            <img :src="`/images/dropzone/${icon}`" alt="" role="presentation" />
            <div class="dropzone-file__preview-image" :style="previewImageStyle" > </div>
        </div>
        <div class="dropzone-file__text">{{file.name}}</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            previewImageStyle: {}
        }
    },
    props: {
        file: {
            type: File,
        }
    },
    computed: {
        isImage() {
            return this.extension.match(/png|jpg|jpeg|gif/);
        },
        extension() {
          return this.file.name.split('.').pop().toLowerCase();
        },
        icon() {
            if (this.isImage) {
                return 'file-image.svg';
            }
            if (this.extension.match('xls')) {
                return 'file-excel.svg';
            }
            return 'file-blank.svg';
        }
    },
    mounted() {
        // Read in preview image if it is a file
        if(this.isImage) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.previewImageStyle = {
                    'background-image' : `url(${e.target.result})`
                };
            }
            reader.readAsDataURL(this.file);
        }
    }
    
};
</script>
